import { render, staticRenderFns } from "./HistoryItems.vue?vue&type=template&id=0d9b342c&scoped=true&"
import script from "./HistoryItems.vue?vue&type=script&lang=ts&"
export * from "./HistoryItems.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryItems.vue?vue&type=style&index=0&id=0d9b342c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9b342c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
